import { FETCH_CHECKS } from "../actions/constants";

const checks = (state = { checks: [] }, action) => {
  switch (action.type) {
    case FETCH_CHECKS:
      return { ...state, checks: action.payload };
    default:
      return state;
  }
};

export default checks;
